import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";

// helpers
import { showMessage } from "../../../helpers/message.js";
import { InputDIAMES } from "../../../helpers/mask";
import { isValidDayMonth } from "../../../helpers/valid";

// api
import diasnaouteis_api from "../../../api/diasnaouteis_api.js";
import usuario_api from "../../../api/usuario_api.js";

export default function DiasNaoUteisFicha({ item, handleReturn }) {

    const { register, errors, handleSubmit, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);
    const [isDisable, set_isDisable] = useState(true);

    const Voltar = () => {
        handleReturn();
    }

    useEffect(() => {
        usuario_api.getFuncionalidadeAcaoLiberada("CadastroDiasNaoUteis", "Editar").then((result) => { set_isDisable(!result); })

        loadForm();
    }, []);

    const loadForm = () => {
        if (item != null) {
            setValue("descricao", item.descricao);
            setValue("diaMes", item.diaMes);
            set_diaMes(item.diaMes);
        }
    }

    const [diaMes, set_diaMes] = useState(null);
    const handleChangeDiaMes = (event) => {
        set_diaMes(event.target.value);
        clearErrors("diaMes");
    }

    const onSubmit = (data) => {
        if (!isValidDayMonth(data.diaMes)) {
            showMessage("Aviso", "Dia/Mês inválido!", 'error', null, null);
            return;
        }

        let json_submit = {
            diasNaoUteis_Id: item != null ? item.diasNaoUteis_Id : 0,
            descricao: data.descricao,
            diaMes: data.diaMes
        };

        setshowLoading(true);
        if (json_submit.diasNaoUteis_Id == 0)
            diasnaouteis_api.post(json_submit).then(result => handleReturnSubmit(result));
        else
            diasnaouteis_api.put(json_submit).then(result => handleReturnSubmit(result));
    }

    const handleReturnSubmit = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else {
            showMessage("Aviso", "Operação executada com sucesso!", 'success', handleReturn);
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row>
                    <Col md="12">
                        <Button color="default" onClick={Voltar}>
                            <i className="fas fa-chevron-left"></i>  Voltar
                        </Button>
                    </Col>
                </Row>
                <Card>
                    <CardHeader>
                        <h4 className="titleCard">Dia Não Útil</h4>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row className="align-items-end">
                                <Col lg="8" md="8" sm="8">
                                    <FormGroup>
                                        <label className="form-control-label">Descrição</label>
                                        <Input className="form-control"
                                            autocomplete="off"
                                            type="text"
                                            name="descricao"
                                            innerRef={register({ required: true })}
                                            disabled={isDisable}
                                        />
                                        {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col lg="3" md="4" sm="4">
                                    <FormGroup>
                                        <label className="form-control-label">Dia/Mês</label>
                                        <InputDIAMES value={diaMes} onChange={handleChangeDiaMes} name="diaMes" inputRef={register({ required: true })} />
                                        {errors.diaMes && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            {!isDisable &&
                                <Row>
                                    <Col lg="12" md="12" sm="12" className="text-center">
                                        <Button color="success" type="submit">
                                            <i className="fas fa-save"></i>  Salvar
                                        </Button>
                                    </Col>
                                </Row>
                            }
                        </Form>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}
